import { AccessType } from '@types';
import { DynamicQueryParams } from '@sonar-software/sonar-ts-types';

import { ApiEndpointHandler, createPostEndpoint } from '@sonar-software/sonar-http';

export type PostDataSecurityAccessExplainerExportRequest = DynamicQueryParams & {
	accessId: string;
	objectId?: string;
	accessType: AccessType;
};

export type PostDataSecurityAccessExplainerExportResponse = { id: number };

const postDataSecurityAccessExplainerExportStart = createPostEndpoint<
	PostDataSecurityAccessExplainerExportRequest,
	PostDataSecurityAccessExplainerExportResponse
>(({ accessId, accessType }) =>
	`/api/v3/core/exports/data-access/explain-access/${accessType}/${accessId}/export/start`);


const postDataSecurityAccessExplainerFieldExportStart = createPostEndpoint<
	PostDataSecurityAccessExplainerExportRequest,
	PostDataSecurityAccessExplainerExportResponse
>(({ accessId, accessType, objectId }) =>
	`/api/v3/core/exports/data-access/explain-access/${accessType}/${accessId}/object/${objectId}/export/start`);


export const postDataAccessExplainerExportStart: ApiEndpointHandler<
	PostDataSecurityAccessExplainerExportRequest,
	PostDataSecurityAccessExplainerExportResponse
> = (request) => {
	if (request.objectId) {
		return postDataSecurityAccessExplainerFieldExportStart(request);
	}

	return postDataSecurityAccessExplainerExportStart(request);
};
